import { clearTokens, getAccessToken } from "../api/apiClient";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:4004";

export function useLogout() {
  const { setIsAuth, setUser } = useAuth();
  const navigate = useNavigate();

  const logout = async () => {
    const accessToken = getAccessToken();
    if (accessToken) {
      try {
        await fetch(`${API_BASE_URL}/auth/logout`, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`, // Backend requires this for authenticateToken middleware
          },
        });
      } catch (err) {
        console.error("Logout error:", err);
      }
    }

    // Clear session storage
    clearTokens();
    setUser(null); // Clear user data from context
    setIsAuth(false);

    // Redirect to login page
    navigate("/login");
  };

  return logout;
}

// Revokes every session for the current account (all devices), not just this one.
export function useLogoutAllDevices() {
  const { setIsAuth, setUser } = useAuth();
  const navigate = useNavigate();

  const logoutAllDevices = async () => {
    const accessToken = getAccessToken();
    if (accessToken) {
      try {
        await fetch(`${API_BASE_URL}/auth/logout-all-devices`, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });
      } catch (err) {
        console.error("Logout-all-devices error:", err);
      }
    }

    clearTokens();
    setUser(null);
    setIsAuth(false);

    navigate("/login");
  };

  return logoutAllDevices;
}

